import React, { useEffect, useRef, useState } from 'react'
import { Button } from '../../Components/Helper'
import { ROUTES } from '../../routes'
import { capitalizeFirstLetter, reduceLongName, squareKilometersToAcres } from '../../ReusableFunctions/reusableFunctions'
import { AEROMEGH_SERVICES, STATUS, STATUS_MESSAGES } from '../../appConstants'
import dateFormat from 'dateformat';
import useWindowSize from '../../hooks/useWindowSize'
import MainContentWrapper from '../../Components/MainContentWrapper'
import { useLocation, useNavigate } from 'react-router'
import VerticalStepper from '../../ReusableComponents/VerticalStepper'
import { cancelRequest, getRequest } from '../../apis/requests'
import RequestDiscount from '../../ReusableComponents/RequestDiscount'
import Loading from '../../ReusableFunctions/Loader'
import L from 'leaflet'
import Popup from "../../ReusableFunctions/Popup";

import SelectComponent from '../../ReusableComponents/SelectComponent'
import infoIcon from '../../assets/info.svg'
import { getDSPsForTransferRequest, transferDSPForRequest } from '../../apis/adminAPIs/dsp'
import DebitIncentiveModal from './components/DebitIncentiveModal'
import Tippy from '@tippyjs/react'
import EditRequestModal from './components/EditRequestModal'
import RequestLocationMap from './components/RequestLocationMap'
import { checkRequestPaymentStatus } from '../../apis/BhuMeetTeams/Oparations/requests'
import { useSelector } from 'react-redux'
import OrderCancelModal from './reusableComponents/CancelOrderModal'
let baseLayer;

const OperationsViewRequest = () => {
    const { state } = useLocation();
    const [steps, setSteps] = useState([])
    const [request, setRequest] = useState()
    const [isButtonVisible, setIsButtonVisible] = useState(false);
    const isTrainingService = request?.type === AEROMEGH_SERVICES.TRAINING
    const isSprayingService = request?.type === AEROMEGH_SERVICES.SPRAYING;
    const isSurveyService = request?.type === AEROMEGH_SERVICES.SURVEY;
    const [activeBaseLayer, setActiveBaseLayer] = useState(baseLayer)
    const [isFullScreen, setIsFullScreen] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [dsps, setDSPs] = useState([]);
    const [debitIncentiveModal, setDebitIncentiveModal] = useState(false);
    const navigate = useNavigate();
    const [selectedDSP, setSelectedDSP] = useState({ label: "Select DSP", value: undefined })
    // const [cancelNote, setCancelNote] = useState("");
    const [fieldInfo, setFieldInfo] = useState(
        { lat: 19.993982, lng: 73.790416, status_history: [] }
    )
    const [userExists, setUserExists] = useState(true);
    const [isEditPopupOpen, setIsEditPopupOpen] = useState(false);
    const [fieldData, setFieldData] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [comments, setComments] = useState([])
    const { user } = useSelector((state) => state.user);
    const { currentWidth } = useWindowSize();
    const [openCancelOrderModal, setOpenCancelOrderModal] = useState(false);

    const Field = ({ label, value, overflow }) => (
        <div className='single_field_wrapper'
            style={{ cursor: label === "Customer Name" || label === "Contact No." ? "pointer" : "default", lineHeight: overflow ? 1.15 : 1.1 }}
            onClick={() => {
                if ((label === "Customer Name" || label === "Contact No.")) {
                    if (!request?.user?.id) return;
                    navigate('/userDetails', { state: { user: request.user } });
                }
            }}
        >
            <div className='single_field_label' style={{ display: "flex", gap: "0.8rem" }} >
                <p>{label}</p>
                {(label === "Sales By" && request?.is_request_incentive_debited) && (
                    <Tippy content={
                        <div className=''>
                            {request?.request_debited_incentive_details?.debit_by === "System" ?
                                <span>Incentive debit by System</span>
                                :
                                <span>Incentive debit by {request?.request_debited_incentive_details?.user_name ?? "Admin"}</span>
                            }
                        </div>
                    }>
                        <span
                            style={{
                                lineHeight: 1.1,
                                fontSize: "15px",
                                fontWeight: 500,
                            }}
                        >
                            <img src={infoIcon} alt={"information"} width={20} height={20} />
                        </span>
                    </Tippy>
                )}
            </div>
            <div className='single_field_value' style={{
                maxHeight: overflow && value?.length > 120 ? "100px" : "none",
                overflowY: overflow && value?.length > 120 ? "auto" : "hidden"
            }}>
                {value || "-"}
            </div>
        </div>
    );

    useEffect(() => {
        if (request) {
            const fieldData1 = [
                { label: 'Sales By', value: request?.sales_by },
                { label: 'DSP Name', value: request?.owner.name },
                { label: 'Request Number', value: request?.req_number },
                { label: 'Customer Name', value: request?.user?.name || "-" },
                { label: 'Location', value: request?.location_address, overflow: true },
                { label: 'Contact No.', value: request?.user?.mobile_number || "-" },
                { label: 'Service Location', value: request?.field_address, overflow: true },
                { label: 'Drone Type', value: request?.drone_type },
                isSprayingService && { label: 'Crop', value: request?.crops?.English || request?.crop_name },
                isSprayingService && { label: 'Agro Chemicals', value: request?.pesticides },
                (isSprayingService || isSurveyService) && { label: 'Drone UIN', value: request?.drone_uin },
                (isSprayingService || isSurveyService) && { label: 'Date', value: request?.time ? dateFormat(request.time, "dd/mm/yyyy") : "-" },
                isTrainingService && { label: 'Date', value: request?.date_created ? dateFormat(request.date_created, "dd/mm/yyyy") : "-" },
                isTrainingService && { label: 'Time', value: request?.date_created ? dateFormat(request.date_created, "hh:MM TT") : "-" },
                (isSprayingService || isSurveyService) && {
                    label: 'Pilot',
                    value: request?.pilot_name ? reduceLongName(request.pilot_name, 20) : "-"
                },
                {
                    label: `Status`,
                    value: `${request?.status} ${request.status === STATUS.PAID ? `(${request.payment_method === "Offline" ? "Cash" : "UPI"})` : ""}`
                },
                isTrainingService && { label: 'Price', value: request?.price ? request.price + " Rs." : "-" },
                (isSprayingService) && { label: request?.price_by === "acre" ? `Requested Area` : "Requested No of Tank ", value: request?.price_by === "tank" ? request?.field_area : request?.price_by === "acre" ? Number(squareKilometersToAcres(request?.field_area)).toFixed(2) + " Acre" : "-" },
                (isSurveyService) && { label: 'Requested Area', value: request?.field_area ? Number(request?.field_area).toFixed(4) + " Sq/km" : "-" },
                ((isSprayingService && request?.service_completed_area) && {
                    label: request.price_by === "acre" ? "Completed Area" : "Completed No Of Tank", value: (request.price_by === "acre" ? Number(squareKilometersToAcres(request.service_completed_area)).toFixed(2) + " Acre" : request.service_completed_area) || "-"
                })
            ].filter(Boolean);
            setFieldData(fieldData1)
        }
    }, [request])

    const getRequestDetails = async () => {
        let requestData = await getRequest({ type: state.request.type || AEROMEGH_SERVICES.SPRAYING, id: state.request.id }, true, true, true, true)
        setFieldInfo(() => ({
            lat: requestData?.request?.field_lat,
            lng: requestData?.request?.field_lng,
            status_history: requestData?.request?.status_history
        }))
        setRequest({
            ...requestData.request,
            type: AEROMEGH_SERVICES.SPRAYING
        })

        if (requestData.request.status === 'Placed') {
            setIsButtonVisible(true)
        } else {
            setIsButtonVisible(false)
        }
        if (!requestData?.request?.user?.id) {
            setUserExists(false);
        }
        setComments(() => requestData?.request?.comments);
        setSteps(requestData.request.status_history.map(record => {
            return {
                label: record.updated_status,
                content: <>
                    <div style={{
                        color: "rgb(59, 59, 59)",
                        fontSize: "13px",
                        fontWeight: "500",
                        wordBreak: "break-word",
                        marginBottom: "0px",
                    }}>{record.updated_status == STATUS.PLACED ? STATUS_MESSAGES.PLACED :
                        record.updated_status == STATUS.ACCEPTED ? STATUS_MESSAGES.ACCEPTED :
                            record.updated_status == STATUS.RESCHEDULED ? STATUS_MESSAGES.RESCHEDULED :
                                record.updated_status == STATUS.OUT_FOR_SERVICE ? STATUS_MESSAGES.OUT_FOR_SERVICE :
                                    record.updated_status == STATUS.INPROGRESS ? STATUS_MESSAGES.INPROGRESS :
                                        record.updated_status == STATUS.COMPLETED ? STATUS_MESSAGES.COMPLETED :
                                            record.updated_status == STATUS.PAID ? STATUS_MESSAGES.PAID :
                                                record.updated_status == STATUS.CANCELLED ? STATUS_MESSAGES.CANCELLED :
                                                    record.updated_status == STATUS.HOLD ? STATUS_MESSAGES.HOLD :
                                                        ""
                        }</div>
                    {record?.note && <div style={{ lineHeight: '16px', margin: '5px 0px', fontSize: '13px', }}>
                        <span style={{ marginRight: '3px', fontWeight: 500, }}>Note :</span><span style={{ color: "#3b3b3b", fontWeight: 500 }}>{record.note}</span>
                        {(record.updated_status === STATUS.CANCELLED && requestData?.request?.cancelledRequestDetails) && <div className='mt-1'>Cancelled By:{requestData?.request?.cancelledRequestDetails?.user_name}</div>}
                        {(record.updated_status === STATUS.CANCELLED && requestData?.request?.cancelledRequestDetails) && <div className='mt-1'>User Role:{requestData?.request?.cancelledRequestDetails?.user_role}</div>}
                    </div>}
                    <div style={{ color: "#727272", fontSize: "13px", fontWeight: "600" }}>{`${dateFormat(new Date(record.time), "h : MM TT")}, ${dateFormat(new Date(record.time), "d mmmm yyyy")}`}</div>
                </>,
                statusColor: record.updated_status == STATUS.RESCHEDULED ? "#E27444" : record.updated_status == STATUS.CANCELLED ? "#EB0000" : "#32B338",
                highlightStatus: record.updated_status == STATUS.RESCHEDULED || record.updated_status == STATUS.CANCELLED
            }
        }))
    }



    const getDSPs = async () => {
        try {
            let dsps = await getDSPsForTransferRequest(state.request.id)
            setDSPs(dsps.droneServiceProviders.map(data => {
                return {
                    label: data.name,
                    value: data.id,
                    ...data
                }
            }))
        } catch (err) {
            console.log("error : ", err);
            Popup.alert("Error", err, "ERROR");
        }
    }
    const cancelRequestFunction = async (requestId, note, isDebitBESIncentive) => {
        try {
            const updatedRequest = await cancelRequest(requestId, note, isDebitBESIncentive)
            setOpenCancelOrderModal(false);
            getRequestDetails()
            Popup.alert("Request cancelled", "Request successfully cancelled!", 'SUCCESS',)
        } catch (e) {
            Popup.alert("Error", e, "ERROR");
        }
    }
    const updateRequestDSP = async () => {
        Loading.set(true)
        let { id, location_id, name, location_address } = selectedDSP;
        let requestId = state.request.id;
        transferDSPForRequest(requestId, location_id, id, name, location_address).then((result) => {
            setRequest({ ...request, ...result.updatedRequest })
            setIsEdit(false)
            Loading.set(false)
            Popup.alert("Success", result.message, "SUCCESS");
        }).catch(error => {
            Loading.set(false)
            Popup.alert("Error", error, "ERROR");
        })
    }

    useEffect(() => {
        Loading.set(true)
        getRequestDetails()
        getDSPs()
        Loading.set(false);
    }, [])

    return (<><MainContentWrapper >
        {
            <OrderCancelModal
                open={openCancelOrderModal}
                onClose={() => {
                    setOpenCancelOrderModal(false);
                }}
                onOrderCancel={async (cancelOrderReason) => {
                    if (request?.is_bes_linked) {
                        Popup.alert("BES linked", "Are you want to debit BES incentive ?", "WARNING", () => cancelRequestFunction(request.id, cancelOrderReason, true), null, "Yes", () => cancelRequestFunction(request.id, cancelOrderReason, false), "No")
                    }
                    else cancelRequestFunction(request.id, cancelOrderReason, false)
                }}
            />
        }
        {debitIncentiveModal && (
            <DebitIncentiveModal
                requestData={{ reqId: request?.id, reqNumber: request?.req_number }}
                open={debitIncentiveModal}
                onSuccess={async () => {
                    await getRequestDetails()
                }}
                onClose={() => {
                    getRequestDetails();
                    setDebitIncentiveModal(false);
                }} />
        )}
        {isEditPopupOpen && (
            <EditRequestModal
                existingRequest={request}
                onClose={() => {
                    getRequestDetails();
                    setIsEditPopupOpen(false)
                }}
            />
        )}
        <div style={{ background: "white", height: "100%", width: "100%", }}>
            <div
                style={{
                    position: "relative",
                    width: "100%",
                    height: "12%",
                    padding: "20px 30px",
                    borderBottom: "1px solid rgba(128, 128, 128, 0.24)",
                    fontSize: "1rem",
                    display: "flex",
                    justifyContent: "space-between", // This aligns left and right
                    alignItems: "center",
                    color: "#1E1E1E",
                    fontWeight: "500",
                }}
            >
                {/* Left content */}
                <div style={{ width: "100%", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <div>Request Details</div>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: "20px" }}>
                        {request?.status === STATUS.COMPLETED && (
                            <Button
                                text={"Check Payment"}
                                className={"btn-large"}
                                style={{ width: "120px", fontSize: "13px" }}
                                onClick={async () => {
                                    try {
                                        Loading.set(true);
                                        let res = await checkRequestPaymentStatus(state.request?.id);
                                        if (res.statusCode === 201) {
                                            await getRequestDetails();
                                            Popup.alert("SUCCESS", "Payment verified and request updated!", "SUCCESS");
                                        } else if (res.statusCode === 200) {
                                            Popup.alert("SUCCESS", res.message || "No pending payments", "SUCCESS");
                                        } else {
                                            Popup.alert("SUCCESS", res.message || "Payment status checked", "SUCCESS");
                                        }
                                        Loading.set(false);
                                    } catch (err) {
                                        Loading.set(false);
                                        const errorMsg = err || "Something went wrong while checking payment";
                                        Popup.alert("ERROR", errorMsg, "ERROR");
                                    }
                                }}
                            />
                        )}
                        {((request?.status === STATUS.CANCELLED || request?.status === STATUS.PAID) && request?.is_bes_linked && !request?.is_request_incentive_debited) && (
                            <Button
                                text={"Debit Incentive"}
                                className={"btn-large"}
                                style={{ width: "120px", fontSize: "13px" }}
                                onClick={() => {
                                    Popup.alert("Request Incentive Debit", "Are you sure you want to debit BES incentive?", "WARNING", () => {
                                        setDebitIncentiveModal(true)
                                    })
                                }}
                            />
                        )}

                        {![STATUS.PAID, STATUS.COMPLETED].includes(request?.status) && !userExists && (
                            <span className='text-red-400 text-sm'>Can't update request details becuase user deleted</span>
                        )}

                        {(![STATUS.PAID, STATUS.COMPLETED].includes(request?.status) && request?.user?.id) && <>
                            {isEdit ? <Button
                                text={"Cancel Edit"}
                                className={"btn-large"}
                                type={"submit"}
                                onClick={() => {
                                    setIsEdit(false)
                                    setSelectedDSP({ label: "Select DSP", value: undefined })
                                }}
                            /> : ![STATUS.COMPLETED, STATUS.PAID, STATUS.CANCELLED].includes(request?.status) ? <>
                                {/* <input
                                    style={{ border: "1px solid #3b3b3b30", padding: "5px 10px", fontSize: "14px" }}
                                    onChange={(e) => {
                                        e.preventDefault()
                                        setCancelNote(e.target.value)
                                    }}
                                    labelStyle={{ marginLeft: "5px" }}
                                    value={cancelNote}
                                    label={"Cancellation Note"}
                                    type={"text"}
                                    id={"type"}
                                    placeholder={"Enter Cancellation Note"}
                                    name={"note"}
                                /> */}
                                <Button
                                    // isDisabled={!cancelNote}
                                    text={"Cancel"}
                                    className={"btn-large"}
                                    onClick={() => {
                                        setOpenCancelOrderModal(true);
                                    }}
                                />
                            </> : null}

                        </>
                        }

                        {![STATUS.PAID, STATUS.COMPLETED].includes(request?.status) && request?.user?.id ?
                            <Button
                                isDisabled={isEdit && (selectedDSP.value == undefined || request.dsp_id == selectedDSP.value)}
                                text={isEdit ? "Done" : "Edit"}
                                className={"btn-large"}
                                type={"submit"}
                                onClick={() => {
                                    setIsEditPopupOpen(true);
                                }}
                            />
                            : null}


                    </div>
                </div>
            </div>

            <div style={{ background: "white", position: "relative", display: "flex", width: "100%", height: "92%" }}>
                <div style={{ width: "80%", height: "auto", overflowY: "scroll", borderRight: "1px solid #8080803d" }}>
                    <div style={{ position: "relative", padding: "20px 30px", height: "auto", overflowY: "scroll", width: "100%", }}>
                        <div className='request_fields_wrapper'>
                            {fieldData.map((field, index) => (
                                isEdit && field.label == "DSP Name" ?
                                    <div>
                                        <div className='single_field_label'>{field.label}</div>
                                        <SelectComponent
                                            controlStyle={{ height: "32px", width: "200px", minHeight: "20px", border: "none", boxShadow: "0px 2px 5px 1px #6273943d", color: "hsl(0deg 0% 20% / 64%)", fontSize: "10px" }}
                                            placeholder={"Select DSP..."}
                                            menuPlacement={"bottom"}
                                            list={dsps}
                                            value={selectedDSP}
                                            onChange={(data) => { setSelectedDSP(data) }
                                            }
                                        />
                                    </div>
                                    : <Field key={index} label={field.label} value={field.value} overflow={field.overflow} />
                            ))}
                        </div>
                    </div>
                    <div style={{ display: "flex", width: "100%", justifyContent: "space-between" }}>
                        <div style={{ width: currentWidth < 1500 ? "45%" : "40%", margin: "25px 25px 30px 25px" }}>
                            {request?.invoice && <RequestDiscount
                                hideToggle
                                oldRequest={request || {}}
                                request={request}
                            />}

                        </div>
                        <div className='w-[400px] h-[200px]'>
                            <RequestLocationMap
                                lat={fieldInfo?.lat}
                                lng={fieldInfo?.lng}
                                status_history={fieldInfo?.status_history}
                            />

                        </div>
                    </div>

                </div>
                <div className="w-[20%]">
                    <VerticalStepper
                        steps={steps}
                        requestId={request?.id}
                        comments={comments}
                        isLoading={isLoading}
                        isCommentEditable={!user?.is_pdrl_admin}
                    />
                </div>


            </div>
        </div>
    </MainContentWrapper > </>);
};
export default OperationsViewRequest;